import React from "react";
import Logo from "../images/MY-Anlook.png";

export default function LoadingScreen({ text = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center relative montserrat-font-1">
      <div className="flex flex-col items-center">
        <div className="relative w-24 h-24 animate-pulse">
          <img
            src={Logo}
            alt="Loading"
            className="w-full h-full object-contain"
          />
          <div className="absolute inset-0 rounded-full bg-green-500 opacity-20 animate-[ping_1.5s_ease-out_infinite]"></div>
        </div>
        <p className="mt-4 text-sm text-gray-600 font-medium animate-pulse montserrat-font-2">
          {text}
        </p>
      </div>
    </div>
  );
}
